import React, { useMemo, useState, useRef, useEffect } from "react";
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';

import "../styles/components/ticket.scss";

import { convertIntegerToMoney } from "../../modules/helpers";
import { R$ } from "../utils/brl";
import Button from "./layout/button";
import Icon from "./layout/icon";
import ResultCard from "./layout/resultCard";

import { generateImage, shareImage } from "../../newDesign/utils/generateImage";
import { getNumberLength } from "../utils/getNumberLength";
import { hasBitLogin } from "../../utils/getPreTickets";

/**
 *
 * @param {{
 *  bilhetes: {
 *    bets: {
 *      number: string,
 *      amount: number
 *  },
 *  value: number,
 *  date: string,
 *  extraction: string,
 *  concurso: string,
 *  info: {
 *      number: number,
 *      serial: string
 *  },
 *  prize: string,
 * name: string
 * image: string
 * isLoteria: boolean
 * }[],
 * onClose: () => void
 * preTicket?: string,
 * autoDownload?: false,
 * objTipoJogo?: object
 * isBicho: boolean
 * }} props
 */
export default function Ticket({ bilhetes = [{}], onClose, GoToPreTicket, preTicket, onDelete, toggleErrorModal, objTipoJogo, isBicho }) {
  const [activeBilheteIndex, setActiveBilheteIndex] = useState(0);
  const divRef = useRef(null);
  /**
   *
   * @param {string} title
   * @param {string} data
   * @param {string} subtitle
   * @returns
   */
  if(GoToPreTicket) GoToPreTicket();

  const numberLength = getNumberLength(objTipoJogo, isBicho);

  const preTicketSection = preTicket &&
      <main className="preticket-qrcode-container">
        <div className="preticket-qrcode-number">
            <p>Número do pré-ticket:</p>
            <h3><strong>{preTicket}</strong></h3>
        </div>
        <div className="preticket-qrcode">
            <QRCodeSVG value={preTicket} />
        </div>
        {onDelete &&
          <div className="preticket-qrcode">
            <button onClick={onDelete} type="button" className="rifa-button preticket-delete btn btn-danger">
                Excluir
            </button>
          </div>
        }
      </main>;

  const row = (title, data, subtitle) => {
    if (!data) {
      return <React.Fragment></React.Fragment>;
    }

    return (
      <React.Fragment>
        <p>
          <strong>{title}: </strong>
          <span>{data}</span>
          {subtitle ? (
            <React.Fragment>
              <br />
              <small>{subtitle}</small>
            </React.Fragment>
          ) : null}
        </p>
      </React.Fragment>
    );
  };

  const renderTicket = (hideButtons = false) => {
    const styleForHideTicket = {
      zIndex: -1,
      top: `-3000px`
    }

    return (
      <React.Fragment>
        <div className="rifa-ticket" style={hideButtons?styleForHideTicket:{}}>
          <div
            className="rifa-ticket__all_background"
            style={{
              transform: `translateX(${0 - 100 * activeBilheteIndex}vw)`,
            }}
          >
            {bilhetes &&
              bilhetes.map(
                (
                  {
                    bets,
                    value,
                    date,
                    prize,
                    extraction,
                    concurso,
                    venda,
                    name,
                    image,
                    isLoteria = true,
                    arrJogo,
                    intNumeroPule,
                    vchCodigoSeguranca,
                    chrSerial,
                    leagues,
                    teams,
                  },
                  index
                ) => {
                  const teamValue = useMemo(() => {
                    if (!teams) {
                      return 0;
                    }

                    return convertIntegerToMoney(
                      teams.reduce((sum, item) => sum + item.valor, 0)
                    );
                  }, [teams]);

                  const leagueValue = useMemo(() => {
                    if (!leagues) {
                      return 0;
                    }

                    return convertIntegerToMoney(
                      leagues.reduce((sum, item) => sum + item.valor, 0)
                    );
                  }, [leagues]);

                  const betsLength = useMemo(() => {
                    if (arrJogo) {
                      return arrJogo.length;
                    }

                    if (bets) {
                      return bets.length;
                    }

                    if (teams || leagues) {
                      return (leagues || []).concat(teams || []).length;
                    }

                    return undefined;
                  }, [arrJogo, bets, teams, leagues]);

                  return (
                    <div className="rifa-ticket__background">
                      <div  style={{position: "absolute", height: "100vh", width: "100vw",}}
                      onClick={onClose}></div>
                      <div className="rifa-ticket__container" ref={divRef}>
                        <div className="rifa-ticket__cropped_top"></div>
                        {!hideButtons&&
                        <div className="rifa-ticket__header">
                          <button className="rifa-button" onClick={onClose}>X</button>
                        </div>
                        }
                        <div className="rifa-ticket__content" key={name + index}>
                          <p className="rifa-ticket__title rifa-title">
                            {!!image ? (
                              <img src={image} />
                            ) : (
                              preTicket ? "Pré-Ticket" : "Comprovante de Aposta"
                            )}
                          </p>
                          <div className="rifa-ticket__details">
                            {row("Aposta realizada em", date.replace(",", "").slice(0, -3))}
                            {row("Venda", venda)}
                            {row("Bilhete", intNumeroPule)}
                            {row("Código de Segurança", vchCodigoSeguranca)}
                            {row("Serial", chrSerial)}
                            {!!isLoteria
                              ? row("Extração", extraction)
                              : row("Concurso", concurso)}
                            <hr className="divider"></hr>
                            {row("Valor apostado", R$(value))}
                            <p className="rifa-ticket__bets-header rifa-subtitle"></p>
                            {row("Quantidade de apostas", betsLength)}
                            {arrJogo &&
                              arrJogo.map((jogo, index) => (
                                <ResultCard
                                  isBallType={!isLoteria}
                                  index={index + 1}
                                  title={jogo.nome}
                                  key={jogo.nome}
                                  valorTotal={convertIntegerToMoney(jogo.valor)}
                                  numbers={jogo.arrNumeros}
                                  premio={jogo.premio}
                                  numberLength={numberLength}
                                  tipoJogo={jogo.tipoJogo}
                                  isBicho={isBicho}
                                />
                              ))}
                            {bets && (
                              <ResultCard
                                isBallType={!isLoteria}
                                cart={bets}
                                index={arrJogo ? arrJogo.length + 1 : 1}
                                title={name}
                                numberLength={numberLength}
                                isBicho={isBicho}
                              />
                            )}
                            {leagues && leagues.length > 0 && (
                              <ResultCard
                                title={`${name} - Ligas`}
                                valorTotal={leagueValue}
                                index={1}
                                teams={leagues}
                                numberLength={numberLength}
                              />
                            )}
                            {teams && teams.length > 0 && (
                              <ResultCard
                                title={`${name} - Times`}
                                valorTotal={teamValue}
                                index={leagues && leagues.length > 0 ? 2 : 1}
                                teams={teams}
                                numberLength={numberLength}
                              />
                            )}
                          </div>
                          {bilhetes && bilhetes.length > 1 && (
                            <div className="ticket-pagination">
                              <Button
                                className="rifa-button"
                                color="main"
                                onClick={() =>
                                  setActiveBilheteIndex((state) => state - 1)
                                }
                                disabled={activeBilheteIndex === 0}
                                style={{ transform: "rotate(180deg)" }}
                              >
                                <Icon type="chevronRight" color="white" />
                              </Button>

                              <div className="pagination-dots">
                                {bilhetes.map((Bilhete, index) => (
                                  <div
                                    className={`dot ${
                                      index === activeBilheteIndex ? "active" : ""
                                    }`}
                                    onClick={() => setActiveBilheteIndex(index)}
                                    key={index}
                                  />
                                ))}
                              </div>
                              <Button
                                className="rifa-button"
                                color="main"
                                onClick={() =>
                                  setActiveBilheteIndex((state) => state + 1)
                                }
                                disabled={
                                  activeBilheteIndex >= bilhetes.length - 1
                                }
                              >
                                <Icon type="chevronRight" color="white" />
                              </Button>
                            </div>
                          )}
                          {preTicketSection}
                        </div>

                        {(!hideButtons && !hasBitLogin()) ?
                        <div className="rifa-ticket__buttons">
                          <Button
                            className="rifa-button"
                            color="main"
                            onClick={() =>generateImage(divRef, toggleErrorModal, venda)}
                          >
                            <Icon type="download" color="white" />
                            {preTicket ? "Baixar Pré-Ticket" : "Baixar Comprovante"}
                          </Button>
                          <Button
                            className="rifa-button"
                            color="main"
                            onClick={() =>{shareImage(divRef, toggleErrorModal, venda)}}
                          >
                            <Icon type="share" color="white" />
                          </Button>
                        </div>
                        : null}

                        <div className="rifa-ticket__cropped_bottom"></div>
                      </div>
                    </div>
                  );
                }
              )}
          </div>
        </div>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {renderTicket(false)}
      {renderTicket(true)}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/rifa/components/ticket.jsx